import { Box, Button, Img, Text } from '@chakra-ui/react';
import { useContext, useEffect, useState } from 'react';
import { ScoreContext, ProfileType } from '../GamePreview';
import { ProfileContext } from '../EntirePreview';
import { motion } from 'framer-motion';
import Scrollbar from 'components/customScroll/CustomScroll';
import { API_SERVER } from 'config/constant';

type replayScoreProps = {
  preloadedAssets: any;
  setReplayIsOpen: (value: boolean) => void;
  replayState?: string;
  handleReplayButtonClick?: (replayState: string) => void;
  setCurrentScreenId?: (id: number) => void;
  gameInfo?: any;
  profilescore?: any;
  setOptionalReplay?: (value: boolean) => void;
  getPrevLogDatas: any;
  setQuestState: any;
  setOptions: any;
  setType: any;
  setData: any;
  gameInfoquest: any;
  gameinfodata: any;
  profileData: any;
  setPreLogDatas: any;
  replayNextHandler: any;
  data: any;
  handleClick: () => void;
  feed: string;
  setSelectedOption: any;
  selectedOption: any;
  setAudioObj: any;
  isScreenshot: any;
  options: any;
};

const ReplayScore: React.FC<replayScoreProps> = ({
  preloadedAssets,
  setReplayIsOpen,
  replayState,
  handleReplayButtonClick,
  setCurrentScreenId,
  gameInfo,
  profilescore,
  setOptionalReplay,
  getPrevLogDatas,
  setQuestState,
  setOptions,
  setType,
  setData,
  gameInfoquest,
  gameinfodata,
  profileData,
  setPreLogDatas,
  replayNextHandler,
  data,
  handleClick,
  feed,
  selectedOption,
  setSelectedOption,
  setAudioObj,
  isScreenshot,
  options,
}) => {
  const [replayMessage, setReplayMessage] = useState<string>(null);
  const [translatedContentByLanguage, setTranslatedContentByLanguage] =
    useState(null);

  const playerInfo = useContext(ProfileContext);
  const { profile, setProfile } = useContext(ScoreContext);
  const initialProfileObject: ProfileType = {
    score: [],
    // completionScore: [],
    completedLevels: ['1'],
    compQuest: [],
    currentQuest: 1,
    replayScore: [],
    playerGrandTotal: { questScores: {} },
    playerGender: '',
    PlayerName: '',
  };
  const EnumType = {
    BGM: 'bgm',
    VOICE: 'voice',
  };
  useEffect(() => {
    const currentQuestMasterData = gameInfo?.gameQuest.find(
      (item: any) => item.gameQuestNo == profile?.currentQuest,
    );

    if (replayState === 'mandatoryReplay') {
      const currentQuestIndex = profile?.currentQuest;
      const previousQuestScore =
        profile?.playerGrandTotal.questScores[currentQuestIndex] !== null &&
        Object.entries(profile?.playerGrandTotal?.questScores).length > 0
          ? profile?.playerGrandTotal.questScores[currentQuestIndex]
          : 0;
      const finalPlayerScore = previousQuestScore
        ? parseInt(previousQuestScore)
        : 0;
      const differedScore =
        parseInt(currentQuestMasterData.gameMinScore) - finalPlayerScore;

      setReplayMessage(
        `You are only ${
          differedScore ?? 'few'
        } points away from meeting the passing score. Please try again.`,
      );
    } else if (replayState === 'optionalReplay') {
      const if_firstgotfull_score = profile?.score;
      const sumscore: any = {};
      if_firstgotfull_score?.forEach((score: any) => {
        const quest = score.quest;
        if (!sumscore[quest]) {
          sumscore[quest] = 0;
        }
        sumscore[quest] += score.score;
      });

      const currentQuestIndex = profile?.currentQuest;
      const previousQuestScore =
        profile?.playerGrandTotal.questScores[currentQuestIndex] !== null &&
        Object.entries(profile?.playerGrandTotal?.questScores).length > 0
          ? profile?.playerGrandTotal.questScores[currentQuestIndex]
          : 0; // Default to 0 if undefined

      if (currentQuestMasterData.gameTotalScore) {
        const finalPlayerScore = previousQuestScore
          ? parseInt(previousQuestScore)
          : 0;

        const formDatadistinScore = currentQuestMasterData.gameTotalScore
          ? parseInt(currentQuestMasterData.gameTotalScore)
          : 0;
        const differedScore = formDatadistinScore - finalPlayerScore;
        if (differedScore !== 0) {
          if (
            sumscore[currentQuestIndex] ===
            currentQuestMasterData.gameTotalScore
          ) {
            setReplayMessage(`Would you like to replay?`);
          } else {
            setReplayMessage(
              `You are only ${differedScore} points away from a perfect score. Would you like to replay?`,
            );
          }
        } else {
          setReplayMessage(`Would you like to replay?`);
        }
      } else {
        setReplayMessage(`Would you like to replay?`);
      }
    } else if (replayState === 'blockDelete') {
      const currentQuestIndex = profile?.currentQuest;
      setReplayMessage(
        `You have been brought to the previous block due to a deletion`,
      );
    } else if (replayState === 'questDelete') {
      const currentQuestIndex = profile?.currentQuest;
      setReplayMessage(
        `Current Quest has been removed, Click Okay to return Quest Screen`,
      );
    } else if (replayState === 'noBlock') {
      const currentBlockSequence = data?.blockPrimarySequence;
      // setReplayMessage(`Block ${currentBlockSequence} is not Available, Kindly check it in Game Drafting`)
      setReplayMessage(
        `This is an empty block. You may go back to the game creation tab and add content to this block`,
      );
    } else if (replayState === 'noNavigation') {
      const currentQuestIndex = profile?.currentQuest;
      const currentBlockSequence = data?.blockPrimarySequence;
      // setReplayMessage(`Block ${currentBlockSequence} not has navigation, Kindly update it in Game Drafting. Click 'Okay' to proceed..!`)
      setReplayMessage(
        `The previous block does not have the next sequence defined. To continue the story, you may go back to the game creation tab and add a sequence to this block via the navigate icon on the right.`,
      );
    } else if (replayState === 'Nocompletion') {
      setReplayMessage(
        `You have completed this branch of the story. To add a completion screen, you may navigate back to the game creation tab and head to the Design section.`,
      );
    }
    // else {
    //   setReplayMessage(`Would you like to play again?`);
    // }
  }, [replayState]);
console.log(selectedOption,'selectedOptioninreplayscre')
  useEffect(() => {
    if (selectedOption !== '' && replayState === 'replayPointPrompt') {
      feedBackAudioPlay();
    }
  }, [selectedOption, replayState]);

  const feedBackAudioPlay = async () => {
    if (selectedOption !== '' && profileData?.Audiogetlanguage.length === 0) {
      const AccessFindUrl = options[selectedOption];

      const FindUrl = AccessFindUrl?.qbfeedbackAudioUrl;

      if (FindUrl?.length > 0) {
        try {
          const optionFeedBackAudio = FindUrl ? FindUrl : '';

          if (optionFeedBackAudio !== '') {
            const fullUrl = `${API_SERVER}${optionFeedBackAudio}`;
            const responseblockText = await fetch(fullUrl);

            if (responseblockText.ok) {
              setAudioObj((prev: any) => ({
                ...prev,
                url: fullUrl,
                type: EnumType.VOICE,
                loop: false, // Voice doesn't loop
                autoplay: true, // Autoplay is disabled
              }));
            }
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
    }
  };

  return (
    <>
      <Box id="container" className="Play-station">
        <Box className="top-menu-home-section">
          <Box className="Setting-box">
            <motion.div
              initial={{ scale: 0.5 }}
              animate={{ scale: 1 }}
              transition={{
                type: 'spring',
                stiffness: 300,
                damping: 20,
              }}
              style={{
                width: '100%',
                height: '100%',
                // backgroundColor: 'coral',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {[
                'redirectToChapter',
                'Replay',
                'Minimum',
                'Prompt',
                'blockDelete',
                'noNavigation',
                'noBlock',
                'questDelete',
                'replayPointPrompt',
                'optionalReplay',
                'Nocompletion',
                'mandatoryReplay',
              ].includes(replayState) ? (
                <>
                  <Img
                    src={
                      replayState === 'replayPointPrompt'
                        ? preloadedAssets?.ReplayPointBg
                        : preloadedAssets?.Replay
                    }
                    className="setting-pad"
                  />

                  <Box
                    className={
                      replayState === 'Prompt'
                        ? 'replay-prompt-vertex'
                        : replayState === 'noNavigation' ||
                          replayState === 'Nocompletion'
                        ? 'replay'
                        : 'replay-vertex replayPointPrompt'
                    }
                  >
                    <Box
                      w={'100%'}
                      h={'100%'}
                      display={'flex'}
                      flexDirection={'column'}
                      justifyContent={'space-between'}
                    >
                      {replayState === 'Replay' && (
                        <>
                          <Box className="replay_game_text" zIndex={10}>
                            Would you like to play Again ?
                          </Box>
                          <Box
                            display={'flex'}
                            justifyContent={'space-between'}
                            w={'100%'}
                          >
                            <Button
                              p={'0'}
                              h={'auto'}
                              background={'transparent !important'}
                            >
                              <Img
                                src={preloadedAssets?.NextBtn}
                                onClick={() => setReplayIsOpen(false)}
                                className="replay_game_btn"
                              />
                            </Button>
                            <Button
                              p={'0'}
                              h={'auto'}
                              background={'transparent !important'}
                            >
                              <Img
                                src={preloadedAssets?.replayBtn}
                                className="replay_game_btn"
                              />
                            </Button>
                          </Box>
                        </>
                      )}
                      {replayState === 'Minimum' && (
                        <>
                          <Box className="replay_game_text">
                            Your score is too low than required score please
                            play again ?
                          </Box>
                          <Box
                            display={'flex'}
                            justifyContent={'center'}
                            w={'100%'}
                          >
                            <Button
                              p={'0'}
                              h={'auto'}
                              background={'transparent !important'}
                            >
                              <Img
                                src={preloadedAssets?.OkayBtn}
                                className="replay_game_btn"
                              />
                            </Button>
                          </Box>
                        </>
                      )}

                      {replayState === 'replayPointPrompt' && (
                        <>
                          <Scrollbar height="60%">
                            <Box
                              className="replay_game_text replayPointPrompt"
                              display={'flex'}
                              justifyContent={'center'}
                            >
                              <Box w={'100%'}>
                                {feed ||
                                  `You have been redirected to the replay point. Click "Replay" to continue`}
                              </Box>
                            </Box>
                          </Scrollbar>

                          <Box
                            display={'flex'}
                            justifyContent={'center'}
                            w={'100%'}
                          >
                            <Button
                              p={'0'}
                              h={'auto'}
                              background={'transparent !important'}
                            >
                              <Img
                                src={preloadedAssets?.replayBtn}
                                className="replay_game_btn"
                                onClick={() => {
                                  setReplayIsOpen(false);
                                  handleReplayButtonClick(replayState);
                                }}
                              />
                            </Button>
                          </Box>
                        </>
                      )}
                      {replayState === 'questDelete' && (
                        <>
                          <Box className="replay_game_text">
                            {' '}
                            {replayMessage}
                          </Box>
                          <Box
                            display={'flex'}
                            justifyContent={'center'}
                            w={'100%'}
                            onClick={handleClick}
                          >
                            <Button
                              p={'0'}
                              h={'auto'}
                              background={'transparent !important'}
                            >
                              <Img
                                src={preloadedAssets?.OkayBtn}
                                className="replay_game_btn"
                              />
                            </Button>
                          </Box>
                        </>
                      )}
                      {replayState === 'blockDelete' && (
                        <>
                          <Box className="replay_game_text">
                            {' '}
                            {replayMessage}
                          </Box>
                          <Box
                            display={'flex'}
                            justifyContent={'center'}
                            w={'100%'}
                            onClick={handleClick}
                          >
                            <Button
                              p={'0'}
                              h={'auto'}
                              background={'transparent !important'}
                            >
                              <Img
                                src={preloadedAssets?.OkayBtn}
                                className="replay_game_btn"
                              />
                            </Button>
                          </Box>
                        </>
                      )}
                      {replayState === 'noNavigation' && (
                        <>
                          <div className="replay">
                            <Box className="replay_game_text">
                              {' '}
                              {replayMessage}
                            </Box>

                            <Box
                              w={'100%'}
                              display={'flex'}
                              flexDirection={'column'}
                              justifyContent={' flex-start'}
                              onClick={handleClick}
                            >
                              <Button
                                paddingTop={'60px'}
                                background={'transparent !important'}
                              >
                                <Img
                                  src={preloadedAssets?.OkayBtn}
                                  className="replay_game_btn"
                                />
                              </Button>
                            </Box>
                          </div>
                        </>
                      )}
                      {replayState === 'noBlock' && (
                        <>
                          <Box className="replay_game_text">
                            {' '}
                            {replayMessage}
                          </Box>
                          <Box
                            display={'flex'}
                            justifyContent={'center'}
                            w={'100%'}
                            onClick={handleClick}
                          >
                            <Button
                              h={'auto'}
                              p={'0'}
                              background={'transparent !important'}
                            >
                              <Img
                                src={preloadedAssets?.OkayBtn}
                                className="replay_game_btn"
                              />
                            </Button>
                          </Box>
                        </>
                      )}
                      {replayState === 'optionalReplay' && (
                        <>
                          <Box className="replay_game_text">
                            {replayMessage}
                          </Box>
                          <Box
                            display={'flex'}
                            justifyContent={'space-between'}
                            w={'100%'}
                          >
                            <Button
                              background={'transparent !important'}
                              p={'0'}
                              h={'auto'}
                            >
                              <Img
                                src={preloadedAssets?.replayBtn}
                                onClick={() => {
                                  setReplayIsOpen(false);
                                  handleReplayButtonClick(replayState);
                                }}
                                className="replay_game_btn"
                              />
                            </Button>
                            <Button
                              p={'0'}
                              h={'auto'}
                              background={'transparent !important'}
                            >
                              <Img
                                src={preloadedAssets?.NextBtn}
                                onClick={() => {
                                  setReplayIsOpen(false);
                                  replayNextHandler(data);
                                }}
                                className="replay_game_btn"
                              />
                            </Button>
                          </Box>
                        </>
                      )}
                      {replayState === 'mandatoryReplay' && (
                        <>
                          <Box className="replay_game_text">
                            {' '}
                            {replayMessage}
                          </Box>
                          <Box
                            display={'flex'}
                            justifyContent={'center'}
                            w={'100%'}
                            onClick={() => {
                              setReplayIsOpen(false);
                              handleReplayButtonClick(replayState);
                            }}
                          >
                            <Button
                              p={'0'}
                              h={'auto'}
                              background={'transparent !important'}
                            >
                              <Img
                                src={preloadedAssets?.replayBtn}
                                className="replay_game_btn"
                              />
                            </Button>
                          </Box>
                        </>
                      )}

                      {replayState === 'Nocompletion' && (
                        <>
                          <div className="replay">
                            <Box className="replay_game_text">
                              {' '}
                              {replayMessage}
                            </Box>

                            <Box
                              w={'100%'}
                              h={'100%'}
                              display={'flex'}
                              flexDirection={'column'}
                              justifyContent={' flex-start'}
                              onClick={handleClick}
                            >
                              <Button
                                h={'auto'}
                                paddingTop={'60px'}
                                background={'transparent !important'}
                              >
                                <Img
                                  src={preloadedAssets?.OkayBtn}
                                  className="replay_game_btn"
                                />
                              </Button>
                            </Box>
                          </div>
                        </>
                      )}
                    </Box>
                  </Box>
                </>
              ) : (
                <>
                  {/** ReplayGame prompt*/}
                  <Img
                    src={preloadedAssets?.overview}
                    className="setting-pad"
                  />
                  <Box className="optional-vertex">
                    <Box
                      w={'100%'}
                      h={'100%'}
                      display={'flex'}
                      flexDirection={'column'}
                      justifyContent={'space-between'}
                    >
                      <Text className="replay_game_text">{replayMessage}</Text>

                      <Box
                        display={'flex'}
                        justifyContent={'center'}
                        w={'100%'}
                      >
                        {replayState === 'mandatoryReplay' ? (
                          <>
                            <Button background={'transparent !important'}>
                              <Img
                                src={preloadedAssets?.OkayBtn}
                                onClick={() => {
                                  setReplayIsOpen(false);
                                  handleReplayButtonClick(replayState);
                                }}
                                className="replay_game_btn"
                              />
                            </Button>
                          </>
                        ) : null}
                      </Box>
                    </Box>
                  </Box>
                </>
              )}
            </motion.div>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ReplayScore;
